<template>
  <hello-world />
</template>

<script>
import HelloWorld from '../components/QrCode.vue';

export default {
  name: 'Home',

  components: {
    HelloWorld,
  },
};
</script>
